import { render, staticRenderFns } from "./BannersDetalle.vue?vue&type=template&id=fb208c0c&"
import script from "./BannersDetalle.vue?vue&type=script&lang=js&"
export * from "./BannersDetalle.vue?vue&type=script&lang=js&"
import style0 from "./BannersDetalle.vue?vue&type=style&index=0&id=fb208c0c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports